// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { change } from 'redux-form'
import { AFS_RESULTS_FILTER } from 'redux/modules/interferenceAnalysis/constants'

import {
  success,
  warning,
} from 'react-notification-system-redux'

// when the user selects path(s) to add to the ignore paths table,
// we'll call this. since the scheme for paths in this context is unique,
// we have to do custom transformation.

const importPathsToIgnore = pathData => (dispatch, getState) => {
  // get the currently ignored paths from the results filter
  const { ignoredPaths } = getState().form[AFS_RESULTS_FILTER].values
  const parsedPathData = pathData.reduce((a, d, i) => {
    const {
      band,
      pathId,
      uniqueId,
    } = d

    // if the path is already in the ignore list, don't add it a second time.
    if (ignoredPaths.find(d => d.pathId === pathId) !== undefined) {
      return a
    }

    const rcnNumber = d.rcnNumber.replace('RCN: ', '')

    const site1 = {
      callSign: d.site1.callSign,
      contactCode: d.site1.serviceContactCode,
      siteName: d.site1.siteName,
    }

    const site2 = {
      callSign: d.site2.callSign,
      contactCode: d.site2.serviceContactCode,
      siteName: d.site2.siteName,
    }

    a.push({
      site1,
      site2,
      band,
      pathId,
      rcnNumber,
      uniqueId,
    })

    return a
  }, [])

  const importCount = parsedPathData.length

  // the user tried to import only paths that are already in the import list.
  if (importCount === 0) {
    dispatch(warning({
      message: `The Ignore list already contains the selected path${pathData.length > 1 ? 's' : ''}.`,
    }))
    return
  }

  dispatch(change(
    AFS_RESULTS_FILTER,
    'ignoredPaths',
    [...ignoredPaths, ...parsedPathData]
  ))

  dispatch(success({
    message: `Added ${importCount} path${importCount > 1 ? 's' : ''} to the Ignore list.`,
  }))
}

export default importPathsToIgnore
